/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

/**
 * Controls whether effects use the legacy `microtaskEffect` by default.
 */
export const USE_MICROTASK_EFFECT_BY_DEFAULT = false;
